import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.2188 3.21289L16.8153 3.80951L20.1903 7.18451L20.787 7.78113L20.1903 8.37775L8.80389 19.7642C8.01272 20.5554 6.93966 20.9999 5.82078 20.9999H3.84375H3V20.1561V18.1791C3 17.0603 3.44447 15.9871 4.23564 15.196L15.6222 3.80951L16.2188 3.21289ZM16.2188 5.59937L14.037 7.78113L16.2188 9.96289L18.4005 7.78113L16.2188 5.59937ZM5.42889 16.3892L12.8438 8.97437L15.0255 11.1561L7.61064 18.571C7.13594 19.0457 6.49211 19.3124 5.82078 19.3124H4.6875V18.1791C4.6875 17.5078 4.95418 16.8639 5.42889 16.3892ZM13.125 20.9999H21V19.3124H13.125V20.9999Z",
		fill: "currentColor"
	})
});
export default SvgEditIcon;
